module.exports = __webpack_public_path__ + "img/camel.8bb7025c.png";